import { render, staticRenderFns } from "./ChatMenu.vue?vue&type=template&id=73019861"
import script from "./ChatMenu.vue?vue&type=script&lang=js"
export * from "./ChatMenu.vue?vue&type=script&lang=js"
import style0 from "./ChatMenu.vue?vue&type=style&index=0&id=73019861&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports